import styled from 'styled-components';

interface ContainerProps {
  isShowLabel: boolean;
}
const Container = styled.div<ContainerProps>`
  position: relative;
  padding: 20px;
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border: ${p => p.isShowLabel ? 4 : 0}px solid ${p => p.theme.color.turquoise};
  border-left: ${p => p.isShowLabel ? 4 : 1}px solid ${
  p => p.isShowLabel ? p.theme.color.turquoise : p.theme.color.background};

  button {
    width: 100%;
    height: 41px;
  }
`;

const PopularLabel = styled.div`
  position: absolute;
  top: -29px;
  width: 200px;
  height: 25px;
  display: flex;
  align-items: center;
  margin-left: -24px;
  padding-left: 10px;
  border-radius: 10px 10px 0px 0px;
  background-color: ${props => props.theme.color.turquoise};

  > p {
    text-transform: uppercase;
  }
`;

const Price = styled.div`
  margin: 10px 0;
  height: 74px;
`;

const PriceCost = styled.div`
  margin-right: 20px;
  font-size: 36px;
  line-height: 41px;
  color: ${props => props.theme.color.mainFont};
`;

const PriceDescription = styled.div`
  display: flex;
  flex-direction:column;
  justify-content: flex-end;
  padding-bottom: 7px;

  p {
    line-height: 16px;
  }
`;

const Description = styled.div`
  width: 180px;
  margin-top: 20px;
  font-size: 14px;
  line-height: 21px;
  color: ${props => props.theme.color.mainFont};
`;

export const Styled = {
  Container,
  PopularLabel,
  Price,
  PriceCost,
  PriceDescription,
  Description,
};
